import { ACTIVITY_PAGES } from "constants/activity.constants";

/* */
export const getFilters = state => state.service.filters;

/* The filters on the chat activity page */
export const getChatFilters = state => state.service.chatFilters;

// An object containing all the filters
export const getAllFilters = (state) => ({
  [ACTIVITY_PAGES.ACTIVITY]: getFilters(state),
  [ACTIVITY_PAGES.CHAT_ACTIVITY]: getChatFilters(state),
});
/* */
export const getShowFilterDialog = state => state.service.showFilterDialog;

/* */
export const getChatFilterListText = state => state.service.chatFilterListText;

/* */
export const getFilterListText = state => state.service.filterListText;

/* */
export const getFilterType = state => state.service.filterType;

/* */
export const getFilterDays = state => state.service.filterDays;

/* */
export const getFilterSearch = state => state.service.filterSearch;

/* */
export const getFilterAccountId = state => state.service.filterAccountId;

/* */
export const getFilterLocationId = state => state.service.filterLocationId;

/* */
export const getFilterAccounts = state => state.service.filterAccounts;

/* */
export const getFilterLocations = state => state.service.filterLocations;

/* */
export const getMessage = state => state.service.message;

/* */
export const getActivityDetailOpen = state => state.service.activityDetailOpen;

/* */
export const getContact = state => state.service.contact;

/* */
export const getContactOpen = state => state.service.contactOpen;

/* */
export const getContactChanged = state => state.service.contactChanged;

/* */
export const getActivityViewType = state => state.service.activityViewType;

/* */
export const getContactsSearchText = state => state.service.contactsSearchText;


/* */
export const getUpdatingHoldCalls = state => state.service.updatingHoldCalls;

/* */
export const getUpdatingMessages = state => state.service.updatingMessages;

/* */
export const getUpdateMessagesAgain = state => state.service.updateMessagesAgain;

/* */
export const getStatusSelectionLists = state => state.service.statusSelectionLists;

/* */
export const getStatus = state => state.service.status;

/* */
export const getStatusOpen = state => state.service.statusOpen;

/* */
export const getSmsTask = state => state.service.smsTask;

/* */
export const getSendingSms = state => state.service.sendingSms;

/* */
export const getUpdatingSmsTasks = state => state.service.updatingSmsTasks;

/* */
export const getUpdateSmsTasksAgain = state => state.service.updateSmsTasksAgain;

/* */
export const getBackgroundUpdateSmsTasks = state => state.service.backgroundUpdatingSmsTasks;

/* */
export const getTransferServices = state => state.service.transferServices;

/* */
export const getMessages = state => state.service.messages;

/* */
export const getContactLink = state => state.service.contactLink;

/* */
export const getContactLinkOpen = state => state.service.contactLinkOpen;

/* */
export const getContactLinkContacts = state => state.service.contactLinkContacts;

/* */
export const getAssistOpen = state => state.service.assistOpen;

/* */
export const getContactLinkMenuAnchor = state => state.service.contactLinkMenuAnchor;

/* */
export const getAddContactLink = state => state.service.addContactLink;

/* */
export const getAssistTask = state => state.service.assistTask;

/* */
export const getSendTextOpen = state => state.service.sendTextOpen;

/* */
export const getSourcePhoneNumberId = state => state.service.sourcePhoneNumberId;

/* */
export const getTextPhoneNumber = state => state.service.textPhoneNumber;

/* */
export const getSendingText = state => state.service.sendingText;

/* */
export const getTextSearch = state => state.service.textSearch;

/* */
export const getVerificationCode = state => state.service.verificationCode;

/* */
export const getUnreadMessageCount = state => state.service.unreadMessageCount;

/* */
export const getUnreadChatCount = state => state.service.unreadChatCount;

/* */
export const getBlockNumbersByAccount = state => state.service.blockNumbersAccount;

/* */
export const getPdfContent = state => state.service.pdfContent;

/* */
export const getLast20Messages = state => state.service.last20Messages;

/* */
export const getMessagesLoaded = state => state.service.messagesLoaded;

/* */
export const getShowLoading = state => state.service.showLoading;

/* */
export const getVipCallers = state => state.service.vipCallers;

/* */
export const getReportFiles = state => state.service.reportFiles;

/* */
export const getUnblockNumberState = (state) => {
  return {
    confirmUnblockNumber: state.service.confirmUnblockNumber,
    unblockPhoneNumber: state.service.unblockPhoneNumber,
    unblockAccountId: state.service.unblockAccountId,
  };
};

/* */
export const getPureChatsStartTime = state => state.service.pureChatStartTime;
/* */
export const getPureChatsEndTime = state => state.service.pureChatEndTime;